import { fullPhoneNumber } from 'helpers/common';
import { IServiceGroup } from 'models/shop/serviceGroups';
import { IServicesList } from 'models/shop/shopBookingTemplates';
import { IUserShippingAddresses } from 'models/user/shipping/usershippingaddresses';
import { IUserPreferences } from 'models/user/userpreferences';

export function fullServiceName(service: IServicesList, serviceGroups: IServiceGroup[], t: (v: string) => string) {
	const fullNameParts = [service.name];
	let group = serviceGroups.find((sg) => sg.id === service.serviceGroupId);
	let oldGroup;
	while (group) {
		if (fullNameParts[0] !== group.value) {
			fullNameParts.unshift(group.value);
		}
		oldGroup = group;
		group = serviceGroups.find((sg) => group.parentId && sg.id === group.parentId);
	}
	if (oldGroup?.serviceCategoryId) {
		fullNameParts.unshift(t('DV_ServiceCategories_' + oldGroup.serviceCategoryId));
	}
	return fullNameParts;
}

export function serviceAndServiceGroupName(service: IServicesList, serviceGroups: IServiceGroup[]) {
	const fullNameParts = [service.name];
	let group = serviceGroups.find((sg) => sg.id === service.serviceGroupId);
	while (group) {
		if (fullNameParts[0] !== group.value) {
			fullNameParts.unshift(group.value);
		}
		group = serviceGroups.find((sg) => group.parentId && sg.id === group.parentId);
	}
	return fullNameParts;
}

export function myTelephone(
	userPreferences: IUserPreferences,
	userShippingAddresses: IUserShippingAddresses,
	t,
): string {
	if (userPreferences.callingCodeKey && userPreferences.phoneNumber) {
		return fullPhoneNumber(t, userPreferences.callingCodeKey, userPreferences.phoneNumber);
	}
	if (userShippingAddresses.items?.length) {
		let address = userShippingAddresses.items.find((a) => a.isDefault);
		if (!address) {
			address = userShippingAddresses.items[0];
		}
		return fullPhoneNumber(t, address.callingCodeKey, address.phoneNumber);
	}
	return '';
}
